import React, {useState} from "react";
import {Box, Button, Grid, TextField, Typography, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";
import RisksIcon from "../../../assets/sidebarIcons/RisksIcon";

export default function InputNumberQuestion({
                                                data,
                                                addQuestion,
                                                deleteQuestionsAfterIndex,
                                                goToNextQuestion,
                                                isVisible,
                                                addToUpdateQuestions,
                                                deleteFromQuestionToUpdate,
                                            }) {
    // Constants
    const {t, i18n} = useTranslation();
    const isMobile = useMediaQuery("(max-width:900px)");

    // State management
    const [val, setVal] = useState(data?.currentValue || ""); // Initialize with `data.currentValue` or empty string
    const [showError, setShowError] = useState(false);
    const language = localStorage.getItem("i18nextLng");
    /**
     * Handle input value change
     */
    const handleValueChange = (value) => {
        const numericValue = value === "" ? "" : Number(value); // Allow empty input

        // Validate input
        if (numericValue === "" || numericValue <= 0) {
            setShowError(true); // Show error if empty or <= 0
        } else {
            setShowError(false); // Hide error if valid
        }

        setVal(numericValue); // Update state

        // Delete questions after the current index
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
    };

    /**
     * Handle "Next" button click
     */
    const handleNextClick = async () => {
        if (data && val && val !== data.currentValue) {
            await addToUpdateQuestions(data, val);
        }

        if (data?.question_object) {
            // If there's a follow-up question, add it
            addQuestion(data?.question_object);
        } else {
            // Otherwise, move to the next question
            goToNextQuestion();
        }
    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <Box
            style={{
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            {/* Display Question */}
            <Typography variant="subtitle1">
                {t(data[`question_${i18n.language}`] || data.question)} {/* Multi-language support */}
            </Typography>

            {/* Input Field */}
            <Grid container style={{marginTop: "10px"}}>
                <TextField
                    id="outlined-basic"
                    placeholder={language === "fr" ? "Entrez un nombre" : "Enter a Number"}
                    variant="outlined"
                    fullWidth
                    type="number"
                    value={val || ""}
                    onChange={(e) => handleValueChange(e.target.value)}
                    InputProps={{
                        inputProps: {min: 1}, // Only allow numbers greater than 0
                        sx: {'& input[type=number]': {MozAppearance: 'textfield'}},
                    }}
                />
            </Grid>

            {/* Show Error */}
            {showError && (
                <span className="error-message" style={{marginTop: "4px", color: "#d32f2f"}}>
                    {t("input_required_field")}
                </span>
            )}

            {/* Warnings for special keys */}
            {data?.key === "number_of_employees_B" && val > 1000 && (
                <div style={{display: "flex", gap: "10px", marginTop: "10px", alignItems: "center"}}>
                    <RisksIcon color="#FF840D"/> {/* Icon */}
                    <span style={{color: "#FF840D"}}>{t("warning_employees_B")}</span>
                </div>
            )}
            {data?.key === "turnover_A" && val > 100000 && (
                <div style={{display: "flex", gap: "10px", marginTop: "10px", alignItems: "center"}}>
                    <RisksIcon color="#FF840D"/> {/* Icon */}
                    <span style={{color: "#FF840D"}}>{t("warning_turnover_A")}</span>
                </div>
            )}

            {/* Next Button */}
            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={!val || val <= 0} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>


        </Box>
    );
}